import script from "./clinic-invoice.vue?vue&type=script&setup=true&lang=js"
export * from "./clinic-invoice.vue?vue&type=script&setup=true&lang=js"

import "./clinic-invoice.vue?vue&type=style&index=0&id=735cbe58&scoped=true&lang=css"
import "./clinic-invoice.vue?vue&type=style&index=1&id=735cbe58&scoped=true&lang=css"
import "./clinic-invoice.vue?vue&type=style&index=2&id=735cbe58&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-735cbe58"]])

export default __exports__